import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectExternalProgramMappings = createSelector(
  getSystem,
  ({ externalProgramMappings }) => externalProgramMappings,
);

const selectNormalizedMappings = createSelector(
  selectExternalProgramMappings,
  ({ normalized }) => normalized,
);

const selectNormalizedMappingValues = createSelector(selectNormalizedMappings, Object.values);

export const selectExternalProgramMappingsWithInitialData = createSelector(
  selectNormalizedMappingValues,
  mappings => mappings.map(mapping => ({ ...mapping, initialData: mapping })),
);

const selectPagedProgramMappings = createSelector(
  selectExternalProgramMappings,
  ({ paged }) => paged,
);

export const selectPagedProgramMappingsItems = createSelector(
  selectPagedProgramMappings,
  ({ items }) => items,
);

export const selectPagedProgramMappingsTotalCount = createSelector(
  selectPagedProgramMappings,
  ({ totalCount }) => totalCount,
);

const selectGroupedProgramMappings = createSelector(
  selectExternalProgramMappings,
  ({ grouped }) => grouped,
);

export const selectGroupedProgramMappingsItems = createSelector(
  selectGroupedProgramMappings,
  ({ items }) => items,
);

export const selectGroupedProgramMappingsTotalCount = createSelector(
  selectGroupedProgramMappings,
  ({ totalCount }) => totalCount,
);
